<template>
  <div class="StockCode-manage-wrap">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/stockCodeManage' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>货源码</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/stockCodeManage' }">货源码管理</el-breadcrumb-item>
      <el-breadcrumb-item>迁移货源码</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-row mt-0">
        <div class="toolbar-item">
          <el-button id="auto-0" type="primary" size="small" @click="goBack">返回</el-button>
          <el-button id="auto-1" type="primary" size="small" @click="handleNext" :disabled="selection.length === 0"
            >下一步</el-button
          >
        </div>
      </div>
    </div>

    <div class="table-custom-box" id="auto-2">
      <fe-table
        :tableData="tableData"
        :columns="columns"
        ref="tableRef"
        border
        :show-pagination="true"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
        @selection-change="selectionChange"
        row-key="stockCode"
      >
        <template #selection>
          <el-table-column
            :reserve-selection="true"
            type="selection"
            width="40"
            :selectable="isSelect"
          ></el-table-column>
        </template>
        <template #createDate="{ scope }">
          <span>{{ scope.row.createDate | stamp2TextDate }}</span>
        </template>
      </fe-table>
    </div>
    <el-dialog title="选择货源码" :visible.sync="stockQrVisible" custom-class="tip-dialog">
      <p class="font-red mt-5 mb-5">请选择需要迁移的货源码：</p>
      <div>
        <el-select v-model="targetQrId" placeholder="请选择" style="width: 100%" filterable>
          <el-option v-for="item in stockQrList" :key="item.qrId" :label="item.stockQrName" :value="item.qrId">
          </el-option>
        </el-select>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="handleSurestockQr" :disabled="!targetQrId">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:2
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */

import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import tableMixin from '@/utils/tableMixin';
export default {
  mixins: [tableMixin],
  data() {
    return {
      columns: [
        { label: '装货地', prop: 'loadCity', 'min-width': 100 },
        { label: '装货地名称', prop: 'loadAddressName', 'min-width': 150 },
        { label: '卸货地', prop: 'unLoadCity', 'min-width': 150 },
        { label: '卸货地名称', prop: 'unloadAddressName', 'min-width': 100 },
        { label: '货物', prop: 'stockKindName', 'min-width': 100 },
        { label: '重量/体积', prop: 'unit', 'min-width': 100 },
        { label: '装货时间', prop: 'dispatchDate', 'min-width': 100 },
        { label: '账期', prop: 'paymentDesc', 'min-width': 100 },
        { label: '运价', prop: 'freightRates', 'min-width': 100 },
        { label: '发布时间', prop: 'createDate', 'min-width': 100 }
      ],
      qrId: '',
      tableOptions: { qrcode: '' },
      axiosConfig: { url: api.queryByQrcode }, // 列表接口
      selection: [],
      stockQrList: [],
      stockQrVisible: false,
      targetQrId: ''
    };
  },
  created() {
    this.tableOptions.qrcode = this.$route.query.qrCodeInfo;
    this.qrId = this.$route.params.id;
    this.handleSearch();
  },
  methods: {
    isSelect(row, index) {
      if (!row.matchmakingFlag) {
        return 1;
      } else {
        return 0;
      }
    },
    goBack() {
      this.$router.push({ path: '/stockCodeManage' });
    },
    handleNext() {
      this.targetQrId = '';
      this.stockQrVisible = true;
      this.getStockQrList();
    },
    selectionChange(selection) {
      this.selection = selection;
    },
    async getStockQrList() {
      let res = await axios.post(api.targetStockQrList, { qrId: this.qrId });
      this.stockQrList = res.data;
    },
    async handleSurestockQr() {
      let stockCodes = this.selection.map(el => el.stockCode);
      let res = await axios.post(api.stockCommonMove, { fromQrId: this.qrId, targetQrId: this.targetQrId, stockCodes });
      if (!res.data.moveSuccess) {
        this.stockQrVisible = false;
        this.$message.error(res.data.moveMsg);
        this.selection = [];
        this.$refs.tableRef.handleClearSelection();
        this.handleSearch();
      } else {
        this.stockQrVisible = false;
        this.$message.success('操作成功');
        this.goBack();
      }
    }
  }
};
</script>
